import axios from 'axios';
import useSWR from 'swr';

import { responseInterface } from 'swr/dist/types';
import { MaintenanceMode } from '@domain/appConfig/types';

const path = `${process.env.GATSBY_MRX_API_PUBLIC_URL?.replace(
  /\/$/,
  ''
)}/maintenance-status`;
const swrSettings = {
  dedupingInterval: 5000,
  // Without this, SWR only refetches on mount/focus/reconnect - not
  // continuously. Maintenance mode turning on needs to be detected promptly
  // even if the user just leaves the tab open without refocusing it.
  refreshInterval: 10000,
};

export const getMaintenanceMode = async (): Promise<MaintenanceMode> => {
  const { data } = await axios.get<MaintenanceMode>(path);
  return data;
};

export const useMaintenanceModeCheck = () =>
  useSWR(path, getMaintenanceMode, swrSettings) as responseInterface<
    MaintenanceMode,
    Error
  >;
export default useMaintenanceModeCheck;
